import React, { useState } from "react";
import {
    FormLayout,
    HeaderActions,
    Heading,
    Input,
    LoadingProgress,
    Panel,
    Text,
} from "@/ui";
import { Icon } from "@/components";
import useMeta from "../../base/hooks/useMeta";
import useForm from "../../base/hooks/form/useForm";
import {
    MUTATION_UPDATE_FACEBOOKCATALOG_APP,
    MUTATION_CREATE_FACEBOOKCATALOG_APP,
    QUERY_LIST_STORE_APPS,
} from "../../apollo/module-operations/app";
import _ from "lodash";
import { useMutation } from "@apollo/react-hooks";
import useNotification from "../../base/hooks/components/useNotification";
import styles from "./GeneralsForm.module.scss";

const ExportIcon = () => <Icon icon="export" />;

const FacebookCatalogForm = ({ app }) => {
    const { user } = useMeta();

    const { inputs, setInputs, inputChange } = useForm();

    const [loading, setLoading] = useState(false);

    const notify = useNotification();

    if (!_.get(inputs, "id", null)) {
        setInputs(app);
    }

    const [updateFacebookCatalog] = useMutation(
        MUTATION_UPDATE_FACEBOOKCATALOG_APP,
        {
            skip: user.loading || !user.accountId || !user.storeId,
            refetchQueries: [
                {
                    query: QUERY_LIST_STORE_APPS,
                    variables: {
                        account_id: user.accountId,
                        store_id: user.storeId,
                    },
                    skip: user.loading || !user.accountId || !user.storeId,
                },
            ],
            onCompleted: () => {
                setLoading(false);
                notify(
                    `${
                        inputs.facebook_catalog_url ? "Update" : "Generate"
                    } Facebook Catalog Successfully`,
                    "success",
                );
            },
            onError: () => {
                setLoading(false);
                notify(
                    `Error ${
                        inputs.facebook_catalog_url ? "Creating" : "Updating"
                    } Facebook Catalog`,
                    "error",
                );
            },
        },
    );

    const [createFacebookCatalog] = useMutation(
        MUTATION_CREATE_FACEBOOKCATALOG_APP,
        {
            skip: user.loading || !user.accountId || !user.storeId,
            variables: {
                account_id: user.accountId,
                store_id: user.storeId,
            },
            onCompleted: resp => {
                setInputs(_inputs => {
                    return {
                        ..._inputs,
                        facebook_catalog_url:
                            resp.createFacebookCatalogProducts,
                    };
                });

                let options = {
                    variables: {
                        account_id: user.accountId,
                        store_id: user.storeId,
                        input: {
                            ...inputs,
                            facebook_catalog_url:
                                resp.createFacebookCatalogProducts,
                            type: "FacebookCatalog",
                        },
                    },
                };

                updateFacebookCatalog(
                    _.omit(options, ["variables.input.__typename"]),
                );
            },
            onError: () => {
                setLoading(false);
            },
        },
    );

    const actionLabel = inputs.facebook_catalog_url ? "Update" : "Generate";

    return (
        <Panel
            className={styles.root}
            header={
                <div className={styles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>Facebook Catalog</Heading>
                        <Text tone="secondary" variant="body-sm">
                            Facebook Catalog Information
                        </Text>
                    </div>
                    <HeaderActions
                        actions={[
                            {
                                id: "generate",
                                label: actionLabel,
                                icon: loading ? undefined : <ExportIcon />,
                                loading,
                                disabled: loading,
                                onClick: () => {
                                    setLoading(true);
                                    createFacebookCatalog();
                                },
                            },
                        ]}
                        aria-label="Facebook Catalog actions"
                    />
                </div>
            }
            showHeaderDivider
        >
            {user.loading ? (
                <div className={styles.loading}>
                    <LoadingProgress
                        indeterminate
                        indicator="circular"
                        size="sm"
                        title="Loading"
                    />
                </div>
            ) : (
                <FormLayout>
                    <FormLayout.Section title="Information">
                        <FormLayout.Grid columns={1} maxWidth="twoThirds">
                            <Input
                                fullWidth
                                label="Facebook Catalog Url"
                                name="facebook_catalog_url"
                                onChange={inputChange}
                                value={inputs.facebook_catalog_url || ""}
                            />
                        </FormLayout.Grid>
                    </FormLayout.Section>
                </FormLayout>
            )}
        </Panel>
    );
};

export default FacebookCatalogForm;
